import { BaseModalController } from '../../../base-modal.controller';

export class ModalSetupContatosController extends BaseModalController {
  /*@ngInject*/ constructor($uibModalInstance) {
    super($uibModalInstance);
  }

  public abrirModalAdicionarContato() {
    this.$uibModalInstance.close({ abrirModalCriacao : true });
  }
}
